// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__x9zTy","name":"Header_name__1HED1","birthday":"Header_birthday__31Awq","skeleton":"Header_skeleton__yGez2"};